import { render, staticRenderFns } from "./ModalTrashBasket.vue?vue&type=template&id=0ee09447"
import script from "./ModalTrashBasket.vue?vue&type=script&lang=js"
export * from "./ModalTrashBasket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports